import React from "react";
import { ClockIcon } from "@heroicons/react/solid";
import { BadgeBase } from "@reusejs/react";

export default function QuickTagsComponent() {
  const tags = [
    { label: "Reserve price under 40 Lakh", icon: true },
    { label: "Commercial properties", icon: true },
    { label: "Residential properties", icon: true },
    { label: "Maharashtra", icon: true },
  ];
  return (
    <div className="py-3 px-4 bg-white border-t border-b overflow-x-scroll scrollbar-hide">
      <div className="relative flex sm:flex-row items-center w-full lg:mx-auto lg:max-w-7xl">
        <div className="relative mr-0.5 flex items-center whitespace-nowrap text-sm">
          Quick Tags:
        </div>

        <div className="whitespace-nowrap items-center content-start px-3 lg:px-0 sm:py-0 space-y-1 lg:space-y-0 lg:grid lg:gap-x-2 grid-flow-row ">
          {tags.map((item, index) => {
            return (
              <BadgeBase
                key={index}
                label={item.label}
                badgePrefix={
                  item.icon && (
                    <ClockIcon
                      width="14"
                      height="14"
                      className="text-gray-500 mr-1"
                    />
                  )
                }
                badgeBaseClasses={{
                  padding: "px-3 py-0.5 mr-2",
                  backgroundColor: "bg-white",
                  textColor: "text-gray-700",
                  font: "text-sm font-medium",
                  borderRadius: "border border-gray-300 rounded-md",
                }}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
}
